enum League {
  BOOTCAMP = "Bootcamp",
  BRONZE = "Bronze",
  SILVER = "Silver",
  GOLD = "Gold",
  CHAMPIONS = "Champions",
}

export default League;
